import type { SVGProps } from 'react';
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 8.912a.93.93 0 0 1-.256.642l-5.834 6.058A1.215 1.215 0 0 1 12 16a1.26 1.26 0 0 1-.91-.364L5.254 9.579A.93.93 0 0 1 5 8.937a.93.93 0 0 1 .538-.843.84.84 0 0 1 .954.2l5.507 5.695 5.508-5.718A.86.86 0 0 1 18.125 8a.84.84 0 0 1 .619.27.904.904 0 0 1 .256.641"
    />
  </svg>
);
export default SvgChevronDown;
